// Upload Modal - Production Notes
document.addEventListener('DOMContentLoaded', function () {
    const textarea = document.getElementById('production-notes-textarea');
    const counter = document.getElementById('production-notes-counter');
    const saveButton = document.getElementById('upload-modal-save-continue');
    const modalEl = document.getElementById('upload-modal');
    const iframe = modalEl ? modalEl.querySelector('iframe') : null;
    const limit = 300;

    if (!textarea || !counter || !saveButton || !modalEl) {
        return;
    }

    const updateCounter = function () {
        const length = textarea.value.length;
        counter.textContent =
            `${length}/${limit} ` + (counter.dataset.chars || '');
        if (length > 0) {
            counter.classList.add('prod-notes-counter-active');
        } else {
            counter.classList.remove('prod-notes-counter-active');
        }
    };

    const setTextareaValue = function (value) {
        textarea.value = value || '';
        updateCounter();
    };

    const applyModalData = function (data) {
        if (
            data &&
            Object.prototype.hasOwnProperty.call(data, 'productionNotes')
        ) {
            modalEl.dataset.productionNotes = data.productionNotes || '';
        }
        if (data && Object.prototype.hasOwnProperty.call(data, 'cartLineId')) {
            modalEl.dataset.cartLineId = data.cartLineId || '';
        }
        if (data && Object.prototype.hasOwnProperty.call(data, 'orderLineId')) {
            modalEl.dataset.orderLineId = data.orderLineId || '';
        }
        setTextareaValue(modalEl.dataset.productionNotes || '');
    };

    const getTriggerData = function (trigger) {
        if (!trigger || !trigger.dataset) {
            return null;
        }
        return {
            productionNotes: trigger.dataset.productionNotes || '',
            cartLineId: trigger.dataset.cartLineId || '',
            orderLineId: trigger.dataset.orderLineId || ''
        };
    };

    const onModalShow = function (event) {
        const trigger =
            event && event.relatedTarget ? event.relatedTarget : null;
        modalEl._currentTrigger = trigger || null;

        if (trigger) {
            applyModalData(getTriggerData(trigger));
            return;
        }

        applyModalData({
            productionNotes: modalEl.dataset.productionNotes || '',
            cartLineId: modalEl.dataset.cartLineId || '',
            orderLineId: modalEl.dataset.orderLineId || ''
        });
    };

    const resetModalData = function () {
        modalEl.dataset.productionNotes = '';
        modalEl.dataset.cartLineId = '';
        modalEl.dataset.orderLineId = '';
        modalEl._currentTrigger = null;
        setTextareaValue('');
    };

    textarea.addEventListener('input', updateCounter);
    modalEl.addEventListener('show.bs.modal', onModalShow);
    modalEl.addEventListener('hidden.bs.modal', resetModalData);

    if (typeof window.jQuery !== 'undefined') {
        $(modalEl).on('show.bs.modal', onModalShow);
        $(modalEl).on('hidden.bs.modal', resetModalData);
    }

    saveButton.addEventListener('click', function () {
        const note = textarea.value.trim();
        modalEl.dataset.productionNotes = note;

        const cartLineId = modalEl.dataset.cartLineId;
        const orderLineId = modalEl.dataset.orderLineId;
        const updateUrl = saveButton.dataset.updateUrl;

        const closeModal = function () {
            if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                const bsModal = bootstrap.Modal.getInstance(modalEl);
                if (bsModal) bsModal.hide();
            } else {
                $(modalEl).modal('hide');
            }
        };

        const dispatchSaveEvent = function () {
            // Aggiorna il data-production-notes sul bottone che ha aperto la modale
            if (modalEl._currentTrigger) {
                modalEl._currentTrigger.dataset.productionNotes = note;
            }

            const saveEvent = new CustomEvent(
                'upload-modal-production-notes-save',
                {
                    detail: { note: note }
                }
            );
            modalEl.dispatchEvent(saveEvent);
            window.dispatchEvent(saveEvent);
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage(
                    {
                        type: 'upload-modal-production-notes-save',
                        note: note
                    },
                    window.location.origin
                );
            }
        };

        if (updateUrl && (cartLineId || orderLineId)) {
            saveButton.disabled = true;
            const saveProductionNotes = () => {
                const csrfToken = document.querySelector(
                    'meta[name="csrf-token"]'
                );

                return fetch(updateUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken
                            ? csrfToken.getAttribute('content')
                            : ''
                    },
                    body: JSON.stringify({
                        uuid: cartLineId || orderLineId,
                        productionNotes: note,
                        source: 'upload-modal'
                    })
                });
            };
            const request =
                typeof updateCsrfToken === 'function'
                    ? new Promise((resolve, reject) => {
                          updateCsrfToken()
                              .done(() => resolve(saveProductionNotes()))
                              .fail(reject);
                      })
                    : saveProductionNotes();

            request
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(
                            `Production notes request failed with status ${response.status}`
                        );
                    }

                    return response.json();
                })
                .then(() => {
                    saveButton.disabled = false;
                    dispatchSaveEvent();
                    closeModal();
                })
                .catch((error) => {
                    saveButton.disabled = false;
                    console.error(
                        'Errore salvataggio production notes:',
                        error
                    );
                    dispatchSaveEvent();
                    closeModal();
                });
        } else {
            dispatchSaveEvent();
            closeModal();
        }
    });

    setTextareaValue(modalEl.dataset.productionNotes || '');
});
